<form novalidate [formGroup]="frmQuoteNoteDialog">
  <div class="dialog-heading">
    <span style="flex: 1 1 auto"></span>
    <mat-icon class="close-dialog" aria-hidden="false" mat-dialog-close aria-label="Close icon">close</mat-icon>
  </div>
  <h3 mat-dialog-title>Quote Notes</h3>
  <div mat-dialog-content>
    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
      formControlName="shareType">
      <mat-radio-button class="example-radio-button" *ngFor="let shareType of shareTypes" [value]="shareType?.value">
        {{shareType?.name}}
      </mat-radio-button>
      <mat-error *ngIf="frmQuoteNoteDialog.get('shareType').errors?.required">Please enter a shareType</mat-error>
    </mat-radio-group>
    <br>
    <div>
      <p>Notes</p>
      <textarea formControlName="text" rows="5" cols="85" placeholder="Please add your notes here"></textarea>
      <mat-error *ngIf="frmQuoteNoteDialog.get('text').errors?.required">Please enter a note</mat-error>
      <mat-error *ngIf="frmQuoteNoteDialog.get('text').errors?.maxLength">Note must be max 255 characters</mat-error>
    </div>
  </div>
</form>
<div class="actions-buttom">
  <button mat-flat-button color="accent" (click)="save()" cdkFocusInitial>Save</button>
  <button mat-stroked-button color="accent" (click)="cancel()"> Cancel</button>
</div>
<br>
<div *ngIf="quoteRequestNoteModels.length > 0 ">
  <kendo-grid [data]="gridView">
    <kendo-grid-column field="created" title="Date">
      <ng-template kendoGridCellTemplate let-ua>
        {{ ua.created | date : 'MM/dd/yyyy'}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ownerName" title="Name">
      <ng-template kendoGridCellTemplate let-ua>
        {{ ua.ownerName }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="text" title="Notes">
      <ng-template kendoGridCellTemplate let-ua>
        {{ ua.text }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="actions" title="">
      <ng-template kendoGridCellTemplate let-ua>
        <div *ngIf="this.userIdentity.id === ua.ownerUserId">
          <button mat-flat-button color="accent" cdkFocusInitial (click)="editNote(ua)">
            <mat-icon matPrefix> edit</mat-icon> Edit
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
